import { DoughnutChart } from '../../../commonModules/interface/Chart';

import React, { Component } from 'react';
import Currency from '../../../commonModules/Currency.jsx';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { MonetizationOnRounded } from '@material-ui/icons';
import { Grid, TableRow, TableBody, TableCell } from '@material-ui/core';
import { TableLayout } from '../Stock/containers/Layout';
var $ = require('jquery');

class ProfileBoxItemBoxStatus extends Component{
    state = {
            //Information
            SubscriptionName: '',
            totalPayed: '',
            totalToPay: '',
            lastPaymentDate: '',
            lastPaymentAmount: '',
            nextPaymentDate: '',
            nextPaymentAmount: '',

        }
    componentDidMount() {
        var methodName = 'Get Payment summary';
        var urlBoxFreeOfAssociation = "/money/resume?boxAssoId=" + this.props.boxAssoId;

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            var SubscriptionName = '';
            var totalPayed = '';
            var totalToPay = '';
            var lastPaymentDate= '';
            var lastPaymentAmount= '';
            var nextPaymentDate = '';
            var nextPaymentAmount= '';
            try {
                var data = result; //var data = JSON.parse(result);
                SubscriptionName= data.subscriptionName;
                totalPayed = data.totalPayed;
                totalToPay = data.totalToPay;
                lastPaymentDate = data.lastPaymentDate;
                lastPaymentAmount = data.lastPaymentAmount;
                nextPaymentDate = data.nextPaymentDate;
                nextPaymentAmount = data.nextPaymentAmount;

            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({
                SubscriptionName: SubscriptionName,
                totalPayed: totalPayed,
                totalToPay: totalToPay,
                lastPaymentDate: lastPaymentDate,
                lastPaymentAmount: lastPaymentAmount,
                nextPaymentDate: nextPaymentDate,
                nextPaymentAmount: nextPaymentAmount,
            });
        }.bind(this));
    }
    render() {
        
        const { totalPayed, totalToPay, nextPaymentAmount } = this.state
        const payed = (Math.round( (totalPayed / totalToPay) * 10000) / 100)
        const nextPayment = (Math.round( (nextPaymentAmount / totalToPay) * 10000) / 100)
        // const late = (this.props.recovery ? (Math.round( (this.props.delayPeriod * nextPaymentAmount / totalToPay) * 10000) / 100)  : 0);
        // const restToPay = (this.props.recovery ? (100 - payed - late - nextPayment) : (100 - payed - nextPayment))
        const restToPay =(Math.round((100 - payed - nextPayment)*100) / 100)
        const data = {
            labels: ['Remboursé','Prochain Paiement', 'Reste à Payer'],
            datasets:[
            {
                label:'Etat Paygo',
                data:[
                    payed ,
                    nextPayment,
                    // late,
                    restToPay,
                    
                ],
                backgroundColor:[
                    'rgba(54, 162, 235, 0.6)',
                    'rgba(255, 206, 86, 0.6)',
                    'rgba(255, 99, 132, 0.6)',
                    // 'rgba(75, 192, 192, 0.6)',
                //   'rgba(153, 102, 255, 0.6)',
                //   'rgba(255, 159, 64, 0.6)',
                //   'rgba(255, 99, 132, 0.6)',
                ],
            }
            ]
        }
        return (
            <MiniCard 
                title="Résumé des paiements"
                avatar={<MonetizationOnRounded />}
            >

            <Grid container spacing={2} >
                <Grid item xs={12} sm={7}>
                    <TableLayout>
                        <TableBody>
                            <TableRow>
                                <TableCell component="th">Nom Abonnement</TableCell>
                                <TableCell>{this.state.SubscriptionName}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Total à payer</TableCell>
                                <TableCell><Currency value={this.state.totalToPay} /> </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Total payé</TableCell>
                                <TableCell><Currency value={this.state.totalPayed} /></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Restant à payer</TableCell>
                                <TableCell><Currency value={this.state.totalToPay-this.state.totalPayed} /> </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Date dernier paiement</TableCell>
                                <TableCell>{(new Date(this.state.lastPaymentDate)).toLocaleString('fr-FR')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Montant dernier paiement</TableCell>
                                <TableCell><Currency value={this.state.lastPaymentAmount} /></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Date Prochain paiement</TableCell>
                                <TableCell>{(new Date(this.state.nextPaymentDate)).toLocaleString('fr-FR')}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th">Montant prochain paiement</TableCell>
                                <TableCell><Currency value={this.state.nextPaymentAmount} /></TableCell>
                            </TableRow>

                        </TableBody>
                    </TableLayout>
                    </Grid>
                    <Grid item xs={12} sm={5} >
                        {/* <Donut 
                        val={(Math.round( (this.state.totalPayed / this.state.totalToPay) * 10000) / 100)}
                        val2={(Math.round( (this.state.nextPaymentAmount / this.state.totalToPay) * 10000) / 100)}
                            /> */}
                            {totalPayed &&
                                <DoughnutChart chartData={data} title="Etat PayGo en %" legendPosition="left"/>

                            }
                    </Grid>
                </Grid>
            </MiniCard>

        )
    }
};
export default ProfileBoxItemBoxStatus